import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import TemplateDetail from '../../TemplateDetail/Root';
import 'react-select/dist/react-select.css';
import MoreDots from '../MoreDots';
import DesignSelection from '../../DesignSelection/Root';
import PriorityDropdown from './PriorityDropdown';
import AddToCartButton from './AddToCartButton';
import QuantityDropdown from './QuantityDropdown';
import PrioritiesExpanded from './PrioritiesExpanded';
import CheckedBox from './CheckedBox';
import RemoveButton from './RemoveButton';
import TemplateSubmissionNote from './TemplateSubmissionNote';
import Charm from '../Charm';
import DesignOptions from 'components/SeriesDetail/DesignOptions';
import MiniDesignSelection from 'components/SeriesDetail/MiniDesignSelection/Root';
import MiniSecondaryOption from 'components/SeriesDetail/MiniSecondaryOption';

export const Template = ({
  formattedDesignPrice,
  formattedPriceBand,
  formattedTotal,
  suggestedQuant,
  imgUrls,
  functionalGroupCodes,
  templateId,
  selectedQuantity,
  unsubmittedQuota,
  isDropdownOpen,
  isDetailOpen,
  openDetail,
  closeDetail,
  closeDesign,
  openMultiplePriorities,
  closeMultiplePriorities,
  selectedDesignOption,
  onClickOrTouch,
  closeSelection,
  renderBmwOrMotorradSelection,
  renderMiniSelection,
  modelId,
  templateStatus,
  multiplePriorities,
  inReviewView,
  hasSubmitted,
  toggleSubmissionNote,
  submissionNotificationOpen,
  submittedTemplateQuantity,
  removeTemplate,
  displayPrioritiesExpanded,
  inReview,
  inCart,
  zeroQuantity,
  toggleDropdown,
  duplicateTemplate,
  removeDuplicate,
  isDuplicate,
  duplicate,
  dropDownModelId,
  dropdownDisabled,
  designPackageForTemplate,
  charmsForTemplate,
  mini,
  expand,
  collapse,
  expanded,
  primaryOptions,
  secondaryOptions,
  collapseAndOpenDesign,
  expandMiniMore,
}) => {
  return (
    <div className={styles.templateView} id={templateId}>
      <div className={styles.template}>
        <span className={styles.selectedOptions}>
          <DesignOptions
            designPackage={designPackageForTemplate}
            onClickOrTouch={onClickOrTouch}
            selectedDesignOption={selectedDesignOption}
            expandMiniMore={expandMiniMore}
            isDuplicate={isDuplicate}
            templateId={templateId}
            mini={mini}
            expand={expand}
            primaryOptions={primaryOptions}
            secondaryOptions={secondaryOptions}
          />
          <span className={styles.designPrice}>+ {formattedDesignPrice}</span>
        </span>
        <span className={styles.priceBand}>{formattedPriceBand}</span>
        <span className={styles.totalPrice}>{formattedTotal}</span>
        <span
          className={styles.suggestedQuant}
          onClick={!isDuplicate && hasSubmitted && toggleSubmissionNote}
        >
          <span>{isDuplicate ? duplicate : suggestedQuant}</span>
          {!isDuplicate && hasSubmitted && (
            <span className={styles.asteriskIndicator}>{' *'}</span>
          )}
          <span className={styles.charms}>
            {charmsForTemplate.map(charm => (
              <Charm charm={charm} detail={false} />
            ))}
          </span>
        </span>
        <span className={styles.selectedQuantity}>
          <QuantityDropdown
            isDuplicate={isDuplicate}
            disabled={dropdownDisabled}
            templateId={templateId}
            modelId={dropDownModelId}
            inReviewView={inReviewView}
            openMultiplePriorities={openMultiplePriorities}
            multiplePriorities={multiplePriorities}
            unsubmittedQuota={unsubmittedQuota}
          />
        </span>
        <span className={styles.priority}>
          <PriorityDropdown
            isDuplicate={isDuplicate}
            disabled={dropdownDisabled}
            templateId={templateId}
            modelId={dropDownModelId}
            inReviewView={inReviewView}
            openMultiplePriorities={openMultiplePriorities}
            closeMultiplePriorities={closeMultiplePriorities}
            multiplePriorities={multiplePriorities}
          />
        </span>
        <span className={styles.skinnyColumn}>
          <MoreDots
            isDropdownOpen={isDropdownOpen}
            openDetail={openDetail}
            closeDetail={closeDetail}
            toggleDropdown={toggleDropdown}
            removeTemplate={removeTemplate}
            duplicateTemplate={duplicateTemplate}
            removeDuplicate={removeDuplicate}
            isDuplicate={isDuplicate}
            inCart={inCart}
          />
        </span>
        <span className={styles.buttonColumn}>
          {!isDuplicate && inCart && (
            <CheckedBox templateId={templateId} modelId={modelId} />
          )}
          {zeroQuantity && !isDuplicate && (
            <RemoveButton templateId={templateId} modelId={modelId} />
          )}
          {inReview && !zeroQuantity && !isDuplicate && (
            <AddToCartButton templateId={templateId} modelId={modelId} />
          )}
          {isDuplicate && (
            <button className={styles.removeButton} onClick={removeDuplicate}>
              Remove
            </button>
          )}
        </span>
      </div>
      {displayPrioritiesExpanded && (
        <PrioritiesExpanded
          templateId={templateId}
          modelId={modelId}
          disabled={templateStatus === 'inCart'}
          unsubmittedQuota={unsubmittedQuota}
          multiplePriorities={multiplePriorities}
          openMultiplePriorities={openMultiplePriorities}
          closeMultiplePriorities={closeMultiplePriorities}
        />
      )}
      {isDetailOpen && (
        <TemplateDetail
          modelId={modelId}
          templateId={templateId}
          functionalGroupCodes={functionalGroupCodes}
          closeDetail={closeDetail}
        />
      )}
      {submissionNotificationOpen && (
        <TemplateSubmissionNote quantity={submittedTemplateQuantity} />
      )}

      {renderBmwOrMotorradSelection && (
        <DesignSelection
          templateId={templateId}
          close={closeSelection}
          closeWithoutSaving={closeDesign}
          modelId={modelId}
          selectedDesignOption={selectedDesignOption}
          isDuplicate={isDuplicate}
        />
      )}

      {renderMiniSelection && (
        <MiniDesignSelection
          templateId={templateId}
          close={closeSelection}
          closeWithoutSaving={closeDesign}
          modelId={modelId}
          selectedDesignOption={selectedDesignOption}
          isDuplicate={isDuplicate}
          primaryOptions={primaryOptions}
          secondaryOptions={secondaryOptions}
        />
      )}
      {mini && expanded && (
        <div className={styles.secondaryOptions} onClick={collapse}>
          <div className={styles.secondaryOptionsInner}>
            <span className={styles.options}>
              {secondaryOptions.map(optionKey => (
                <MiniSecondaryOption
                  key={optionKey}
                  optionKey={optionKey}
                  designPackage={designPackageForTemplate}
                />
              ))}
            </span>
            <span onClick={collapseAndOpenDesign} className={styles.modify}>
              Modify design
            </span>
          </div>
          <div className={styles.outerArea} onClick={collapse} />
        </div>
      )}
    </div>
  );
};

export default enhance(Template);
